import gql from 'graphql-tag'

export const pendingTransaction = gql`
  query pendingTransaction($deviceId: ID!) {
    pendingTransaction(deviceId: $deviceId) {
      id
      paygateTransactionId
      paymentUrl
      amountInCents
      currency
    }
  }
`
